import { useTranslation } from "react-i18next";

import { ErrorPages } from "../../../types/Device.types";

export const useLaunchErrorMessage = (errorPage?: ErrorPages) => {
  const { t } = useTranslation();
  let title = t("ERROR_PAGE_GENERIC_HEADER");
  let description = t("ERROR_PAGE_GENERIC_DESCRIPTION");
  const altMessage = t("ERROR_PAGE_IMAGE_ALT_TEXT");

  switch (errorPage) {
    case ErrorPages.BrowserNotSupported:
      title = t("ERROR_PAGE_BROWSER_NOT_SUPPORTED_HEADER");
      description = t("ERROR_PAGE_BROWSER_NOT_SUPPORTED_DESCRIPTION");
      break;
    case ErrorPages.SessionTimeout:
      title = t("ERROR_PAGE_SESSION_TIMEOUT_HEADER");
      description = t("ERROR_PAGE_SESSION_TIMEOUT_DESCRIPTION");
      break;
    case ErrorPages.AcsCallError:
      title = t("ERROR_PAGE_ACS_CALL_ERROR_HEADER");
      description = t("ERROR_PAGE_ACS_CALL_ERROR_DESCRIPTION");
      break;
  }

  return { description, title, altMessage };
};
